
<template>
    <div
        v-if="!$wait.is('loading-page')"
        class="m-faq"
    >
        <y-page-head
            type="simple"
            :overlay="true"
            :element="pageHead"
        />
        <y-container v-if="faq && faq.length">
            <h4
                v-if="description"
                class="typo-h4 color-body-text typo-center ma-0"
            >
                {{ description }}
            </h4>
            <div class="m-faq__section-selector">
                <div
                    v-for="item in faq"
                    :key="`${item.id}-${item.title}`"
                    :class="['m-faq__section-selector__item', item.slug === selectedCategory ? 'active' : '' ]"
                    @click.prevent="selectedCategory = item.slug"
                >
                    <div
                        v-if="item.image"
                        class="m-faq__section-selector__image"
                    >
                        <img
                            :src="item.image[0].versions.main || item.image[0].link"
                            :alt="item.title"
                        >
                    </div>
                    <y-icon
                        v-else
                        icon="mdi-help"
                        library="mdi"
                        size="large"
                        :color="selectedCategory === item.slug ? 'white' : 'secondary'"
                    />
                    <span :class="['typo-h6', `color-${selectedCategory === item.slug ? 'primary' : 'body'}-text`]">
                        {{ item.title }}
                    </span>
                </div>
            </div>
            <y-faq
                v-if="selectedCategory"
                type="simple"
                :items="faq.find((item) => item.slug === selectedCategory).children"
            />
        </y-container>
    </div>
</template>

<script>

    import { YIcon } from '@components';
    import { YPageHead, YFaq } from '@rogues';
    import PageMixin from '@nodes/mixins/Page';

    export default {

        name: 'FAQPage',

        components: {
            YPageHead,
            YFaq,
            YIcon,
        },

        mixins: [PageMixin],

        /**
         * @inheritDoc
         */
        data() {
            return {
                pageTitle       : this.$t('faq.title'),
                pageHead        : null,
                description     : null,
                faq             : null,
                selectedCategory: null,
            };
        },

        methods: {
            /**
             * Fetch faq data
             * 
             * @returns {Promise}
             */
            fetch() {
                const pageHead = this.$services.Content.postList({
                    type  : 'faq',
                    limit : 0,
                    locale: this.$i18n.locale,
                }).catch((error) => {
                    this.handleError(error);
                });

                const faq = this.$services.ContentThemes.faqList({
                    slug     : 'faq',
                    locale   : this.$i18n.locale,
                    including: ['title', 'slug', 'image'],
                }).catch((error) => {
                    this.handleError(error);
                });

                return Promise.all([pageHead, faq]).then((responses) => {
                    if (this.handleReq(responses, 0)) {
                        this.pageHead = {
                            img  : this.get(responses[0].data.metadata, 'configs.type-image'),
                            title: this.get(responses[0].data.metadata, `configs.titles.${this.$i18n.locale}`),
                        };
                        this.description = this.get(responses[0].data.metadata, `configs.description.description.${this.$i18n.locale}`);
                    }

                    if (this.handleReq(responses, 1)) {
                        this.faq = responses[1].data.results.filter((item) => item.id);
                        this.selectedCategory = responses[1].data.results[0].slug;
                    }
                }).catch((error) => {
                    this.handleError(error);
                });
            },
        },

    };
</script>
